// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__AcquH","pagination":"carousel_pagination__ch6ao","customPagination":"carousel_customPagination__p9MwN"};